import React from 'react'
import {DatePicker} from "@mui/x-date-pickers"
import {Grid, TextField, Box, Typography, styled} from "@mui/material"

const FormBox = styled(Box)(() => ({
    maxWidth: "450px",
    padding: "25px",
}))

const Terminformular = () => {
    return <FormBox>
        <Typography variant="h2">Termin vereinbaren</Typography>
        <Grid container direction="row" spacing={2} >
            <Grid item size={6}>
                <DatePicker label="Beratungstermin"/>
            </Grid>
        <Grid item size={6}>
                <TextField label="Beginn"/>
            </Grid>
        <Grid item size={6}>
            <TextField label="Ende"/>
        </Grid>
        <Grid item size={6}>
            <TextField label="Ort"/>
        </Grid>
        <Grid item size={12}>
            <TextField label="Berater"/>
        </Grid>
        <Grid item size={12}>
            <TextField label="Thema"/>
        </Grid>
        <Grid item size={12}>
            <TextField label="Notiz" multiline rows={5}/>
        </Grid>
        </Grid>
    </FormBox>
}

export default Terminformular